module.exports = __webpack_public_path__ + "img/Ymanci_Logo.9706a87d.svg";